import React from "react";
import AboutImage from "./Images";
import {
  Container,
  ImageContainer,
  ContentsContainer,
  Title,
  Text,
  Wrapper,
  BannerImageMD,
  BannerImageSM,
  DotIcon,
  ListBox,
  BulletTitle,
} from "./styles";
import PageContainer from "../PageContainer";
import { Breadcrumb, BreadcrumbItem } from "../Breadcrumb";

const Orthodontist = () => {
  return (
    <>
      <Breadcrumb pageTitle="Who We Are">
        <BreadcrumbItem Link="/orthodontist" Text="Who We Are" />
      </Breadcrumb>

      <PageContainer>
        <Container>
          <Title>Adam Wallace</Title>
          <Text>AHPRA Specialist Registration Number: DEN0001030986</Text>
          <Wrapper>
            <ContentsContainer>
              <Text>
                Adam Wallace is a specialist orthodontist who has had more than
                20 years of experience in the dental profession. He was born and
                raised in Arawata, South Gippsland. His mum owned the Quilter’s
                Barn in Loch, and his dad worked with Graham Rowe at Vin Rowe
                Farm Machinery.
              </Text>
              <Text>
                Adam attended Chairo Christian School (Leongatha campus) and
                went on to complete both his Dentistry, and Orthodontic
                specialist training, at the University of Melbourne. He has
                continued to lecture, demonstrate and examine at the University
                since graduating in 2005. Additionally, he examines overseas
                trained dentists at the Australian Dental Council. As much as
                Adam loves teaching, the majority of his career has been spent
                working in the private practice in Tasmania, Melbourne and
                Gippsland.
              </Text>
              <Text>
                Adam’s undergraduate research was quite apt coming from a dairy
                farm. He studied the casein proteins in milk and the protective
                effect on teeth to help reduce plaque formation. Adam went on to
                graduate the Bachelor of Dental Science degree as valedictorian
                with honours and received a total of ten scholarships, prizes,
                awards and special achievements throughout his undergraduate
                degree.
              </Text>
              <Text>
                Following graduation, he went onto his Masters, researching the
                effects of bisphosphonate use on treatment of benign bone
                disease and impaired dental healing. His passion for academics
                pursued and he has held several academic roles including the
                Clinical Practice and Specialist Areas in Dentistry
                (Orthodontics) Convenor for the Bachelor of Oral Health program.
                Recently, his doctoral thesis was an important clinical study on
                the treatment outcome between Invisalign and traditional braces
                which intends to be published soon.
              </Text>
              <Text>
                Adam is passionate about orthodontics and thoroughly enjoys
                creating beautiful smiles for his patients. He likes to provide
                a personalised approach to his treatment to ensure that patients
                feel welcome and comfortable. Further to this, specialist
                orthodontic training and certification with the Australasian
                Board of Orthodontists has allowed him to appreciate the finer
                attention to detail in treatment. Adam is also a member of the
                national ‘Give a Smile’ program, the charitable arm of the
                Australian Society of Orthodontics.
              </Text>
              <Text>
                Outside Adam’s passion for his work and devotion to his
                patients, he is kept busy with a farm in the Strzelecki ranges
                where he has been living for the last 15 years. He currently has
                angus cattle, sheep, alpacas and a border collie x kelpie dog
                named Hughie, who you can often find at the Gippsland
                Orthodontic clinic ready for a ball throwing session.
              </Text>
              <Text>
                Adam aims to provide specialist care for all his patients with a
                kind, gentle nature and looks forward to seeing several
                generations of patients in the future.
              </Text>
              <BulletTitle>
                <strong>Professional Qualifications</strong>
              </BulletTitle>
              <ListBox>
                <DotIcon />
                <p>Bachelor of Dental Science with Honours (Dux) (Melb)</p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>Doctor of Clinical Dentistry (Orthodontics) (Melb)</p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>Sydney University Orthodontics Long Course (Syd)</p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>
                  Member of Orthodontics, the Royal Australasian College of
                  Dental Surgeons
                </p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>Member of the Pierre Fauchard Academy</p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>Australian Orthodontic Board certified</p>
              </ListBox>

              <BulletTitle>
                <strong>Professional Memberships</strong>
              </BulletTitle>
              <ListBox>
                <DotIcon />
                <p>Australian Society of Orthodontics</p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>American Association of Orthodontics</p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>World Federation of Orthodontists</p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>British Orthodontic Society</p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>Royal Australasian College of Dental Surgeons</p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>Australian Dental Association</p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>Pierre Fauchard Academy</p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>‘Give a Smile’ Program</p>
              </ListBox>

              <BulletTitle>
                <strong>Professional Roles (Past and Current)</strong>
              </BulletTitle>
              <ListBox>
                <DotIcon />
                <p>
                  Committee member of the Australian Society of Orthodontics
                  Victorian Branch
                </p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>
                  Treasurer of the Australian Society of Orthodontics Victorian
                  Branch
                </p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>
                  Committee member for the Australian Society of Orthodontics
                  Melbourne Congress 2026
                </p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>
                  Recent Graduates Committee member with Australian Dental
                  Association Victorian Branch
                </p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>
                  President Recent Graduates Committee with Australian Dental
                  Association Victorian Branch
                </p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>
                  Examiner, lecturer, demonstrator and seminar tutor University
                  of Melbourne
                </p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>Examiner Australian Dental Council</p>
              </ListBox>
              <ListBox>
                <DotIcon />
                <p>Examiner Latrobe University</p>
              </ListBox>
            </ContentsContainer>
            <ImageContainer>
              <AboutImage />
            </ImageContainer>
          </Wrapper>
        </Container>
      </PageContainer>
    </>
  );
};

export default Orthodontist;
